import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import React, { useState } from "react";
import ProductAction from "../stores/actions/ProductAction";

function UpdateProductImage({
  setGallerModal,
  galleryModel,
  renderList,
  proId,
}: any) {
  const handleClose = () => setGallerModal(false);
  const dispatch = useDispatch<any>();
  const [product_image, setProduct_image] = useState<any>("");

  const onSubmitFile = async (val: any) => {
    const inputFile = document.getElementById(
      "product_image"
    ) as HTMLInputElement;
    // console.log(val.target.files[0]);
    setProduct_image(val?.target.files[0]);
  };

  const formHandleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      await dispatch(
        ProductAction.updateProductImage({
          id: proId,
          product_image: product_image,
        })
      );
      handleClose();
      renderList();
      toast.success("Image Updated !");
    } catch (error: any) {
      toast.error(error.message);
      handleClose();
    }
  };

  // console.log(product_image);

  return (
    <div className="modal" style={{ display: galleryModel ? "block" : "none" }}>
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <form onSubmit={formHandleSubmit} encType="multipart/form-data">
            <div className="modal-header">
              <h5 className="modal-title">Update Product Image</h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              />
            </div>
            <div className="modal-body">
              <div className="form-validation">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="mb-3 row">
                      <label className="col-lg-4 col-form-label">
                        Upload Image
                        <span className="text-danger">*</span>
                      </label>
                      <div className="col-lg-8">
                        <input
                          type="file"
                          className="form-control"
                          id={proId}
                          onChange={(event) => onSubmitFile(event)}
                          required={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger light btn-sm"
                data-bs-dismiss="modal"
                onClick={handleClose}>
                Close
              </button>
              <button type="submit" className="btn btn-primary btn-sm">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UpdateProductImage;
